import { useMutation, useQueryClient } from "@tanstack/react-query";

import { resetSkills } from "@/shared/api";
import { ResetButton } from "@/features/skills/components/ResetButton";

/** Self-contained "reset skill profile" Settings section — owns the mutation
 *  + the query invalidations so the host (Settings) just drops it in. Lives
 *  in the skills feature because the invalidated keys are skills-domain. */
export function ResetSkillProfile() {
  const queryClient = useQueryClient();
  const reset = useMutation({
    mutationFn: resetSkills,
    onSuccess: () => {
      for (const key of [
        ["skills"],
        ["leak-report"],
        ["recommended-drill"],
        ["skills-history-overall"],
        ["profile-summary"],
      ]) {
        queryClient.invalidateQueries({ queryKey: key });
      }
    },
  });

  return (
    <section className="rounded-xl border border-border bg-surface p-5">
      <h2 className="text-sm uppercase tracking-wider text-text-muted mb-3">Skill profile</h2>
      <ResetButton pending={reset.isPending} onReset={() => reset.mutate()} />
    </section>
  );
}
